import { createRoot } from "react-dom/client";
import { App } from "./App";
import { getTelegramWebApp } from "./telegram";
import "./styles/app.css";

const tg = getTelegramWebApp();
const container = document.getElementById("root");

// telegram-web-app.js создаёт window.Telegram.WebApp даже вне Telegram (initData тогда пустой
// стрин) — так отличаем реальный запуск из Telegram от захода по прямой ссылке в браузере.
// process.env.PUBLIC_APP_EXTERNAL_URL инлайнится Bun'ом на этапе сборки (bunfig.toml, [serve.static]
// env = "PUBLIC_*"). Вне Telegram: если задан — редирект туда; если не задан — доступ блокируется
// (fail closed), а не молча рендерится приложение.
const isTelegram = Boolean(tg?.initData);
const externalUrl = process.env.PUBLIC_APP_EXTERNAL_URL;

if (!isTelegram && externalUrl) {
  window.location.href = externalUrl;
} else if (!isTelegram) {
  if (container) {
    createRoot(container).render(
      <div className="max-w-[640px] mx-auto p-4">
        <p className="text-text-muted">Доступно только в Telegram.</p>
      </div>,
    );
  }
} else {
  tg?.ready();
  tg?.expand();
  if (container) {
    createRoot(container).render(<App />);
  }
}
